import { Box, CircularProgress, Typography } from "@mui/material";

import { Notification } from "../../types/notification";

import NotificationItem from "./NotificationItem";
import EmptyNotificationsFigure from "./EmptyNotificationsFigure";

const NotificationsList = ({
  data,
  lastSeen,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  onClose,
}: {
  data: any;
  lastSeen?: number;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onClose: () => void;
}) => {
  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.currentTarget;
    const bottom = target.scrollHeight - target.scrollTop - target.clientHeight < 5;
    if (bottom && hasNextPage && !isFetchingNextPage) fetchNextPage();
  };

  const hasNotifications = data?.pages?.some((page: any) => page.data.items.length > 0);

  return (
    <Box sx={styles.container} onScroll={handleScroll}>
      {!hasNotifications && <EmptyNotificationsFigure />}
      {data?.pages?.map((page: any) =>
        page.data.items.map((notification: Notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            lastSeenTime={lastSeen}
            onClose={onClose}
          />
        ))
      )}
      {isFetchingNextPage && <CircularProgress size={24} sx={styles.loadingSpinner} />}
    </Box>
  );
};

export default NotificationsList;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    rowGap: "24px",
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    overflowY: "auto",
  },
  loadingSpinner: {
    margin: "0 auto",
  },
};
